import React from "react";
import AdminLayout from "../components/layout/AdminLayout";
import AdminAnalyticsCards from "../components/admin/AdminAnalyticsCards";
import SlaAnalyticsCards from "../components/admin/SlaAnalyticsCards";
import AnalyticsVisuals from "../components/admin/AnalyticsVisuals";
import SignerDropOffTable from "../components/admin/SignerDropOffTable";
import SectionHeader from "../components/common/SectionHeader";

export default function AnalyticsPage() {
  return (
    <AdminLayout
      title="Analytics"
      subtitle="Monitor document performance, signer engagement, and SLA trends."
    >
      <div className="section-space">
        <SectionHeader
          title="Platform Metrics"
          subtitle="Top-level activity and workflow health indicators."
          chips={["Overview", "Live Metrics"]}
        />
        <AdminAnalyticsCards />
      </div>

      <div className="section-space">
        <SectionHeader
          title="SLA Metrics"
          subtitle="Completion speed and turnaround performance."
          chips={["Time Based", "Performance"]}
        />
        <SlaAnalyticsCards />
      </div>

      <div className="section-space">
        <SectionHeader
          title="Visual Analytics"
          subtitle="Quick visual summary of operational trends."
          chips={["Charts", "Insights"]}
        />
        <AnalyticsVisuals />
      </div>

      <div className="section-space">
        <SectionHeader
          title="Drop-off Detail"
          subtitle="Signers who viewed a document but have not yet completed signing."
          chips={["Attention Needed"]}
        />
        <SignerDropOffTable />
      </div>
    </AdminLayout>
  );
}
